import { createAction } from "@reduxjs/toolkit";

export const copyCurrentUserDefinedTheme = createAction("COPY_CURRENT_THEME");

export const pasteCopiedUserDefinedTheme = createAction("PASTE_COPIED_THEME");
